import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { UpdateMultiAuthSuccessComponent } from "./update-multi-auth-success.component";


class UpdateMultiAuthSuccessFormSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    updateMultiAuthSuccessComponentRef: ComponentRef<UpdateMultiAuthSuccessComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside update multi auth success form constructor');
        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('Update Multi Auth Success Form session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('Update Multi Auth Success Form session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('Update Multi Auth Success Form session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<UpdateMultiAuthSuccessComponent> = self.resolver.resolveComponentFactory(UpdateMultiAuthSuccessComponent);
        self.updateMultiAuthSuccessComponentRef = self.viewContainerRef.createComponent(factory);

        console.log('update multi auth success form constructor payload:', this.payload);

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
              console.log('update multi auth success form createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('update multi auth success form createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('update multi auth success form onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('update multi auth success form onError for ' + this.formId + ' payload:', payload);
      }

}

interface ActionsInPayload {
    [key: string]: any;
  }

export default UpdateMultiAuthSuccessFormSession;
